import axios from "axios";
import { Base_URL } from "../url";

export const loginUser = async (username, password) => {
  try {
    console.log(username, password);
    const response = await axios.post(`${Base_URL}/Logins`, {
      username,
      password,
    });
    console.log(response.data, "resdfd fvbdf ");
    return response;
  } catch (error) {
    throw error.response?.data || { message: "Login failed" };
  }
};

// 🔹 Get all users by organization ID
export const getUsersByOrganization = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Logins/organization/${organisationId}`
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        message: "Failed to fetch users by organization",
      }
    );
  }
};

/* 🔹 GET USER BY ID */
export const getUserById = async (userId) => {
  try {
    const response = await axios.get(`${Base_URL}/Logins/user/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch user details" };
  }
};

/* 🔹 GET MULTIPLE USERS BY IDS */
export const getUsersByIds = async (userIds) => {
  try {
    const response = await axios.post(`${Base_URL}/Logins/users`, {
      userIds,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch multiple users" };
  }
};
